<template>
  <div>
    <Typography h2 bold label="จำนวนผู้สมัครเข้าร่วมโครงการ" style="margin-bottom: 13px"/>
    <div style="padding-left: 48px">
      <v-layout row wrap class="mt-2">
        <v-flex xs12 style="display: flex; margin-bottom: 50px">
          <div style="width: 350px">
            <multiselect
              @input="onChangeDate"
              v-model="filterselect"
              :options="status"
              :searchable="false"
              single-select
              deselect-label
              label="label"
              placeholder="เลือก"
            ></multiselect>
          </div>
          <div class="ml-2 form-control" style="margin-right: 6px; width: 230px">
            <date-picker
              range
              @input="
                onChangeDate()
              "
              :shortcuts="shortcuts"
              :append-to-body="false"
              :clearable="false"
              :editable="false"
              input-class="dateSearch"
              name="DateSearch"
              v-model="selectedDate"
              valueType="date"
              format="DD/MM/YYYY"
              placeholder="เลือกช่วงเวลา"
            >
            </date-picker>
          </div>
        </v-flex>
      </v-layout>
      <div class="text-xs-center pt-5" v-if="loading">
        <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
      </div>
      <div v-else>
        <div v-if="data.length">
          <div v-if="filterselect.value === 1">
            <div>
              <Typography h2 bold label="โครงการ" />
              <v-layout row wrap justify-center>
                <v-flex xs1></v-flex>
                <v-flex xs11>
                  <apexchart
                    :key="piechartkey"
                    type="pie"
                    width="900"
                    class="member-count"
                    :options="pieChartOptions"
                    :series="pieSeries"
                  ></apexchart>
                </v-flex>
              </v-layout>
            </div>
            <Typography h2 bold label="รายละเอียด" style="margin-bottom: 13px"/>
            <v-data-table
              :headers="headers"
              :items="data"
              :loading="loading"
              item-key="id"
              class="elevation-1 expandtable"
              hide-actions
            >
              <template v-slot:items="props">
                <tr class="depatable">
                  <td class="text-xs-left" style="display: flex; align-items: center; margin-left: 29px; font-weight: 600; width: 760px" :style="{ color: pieChartOptions.colors[props.index % 8] }">
                    <div style="width: 12px; height: 12px; border-radius: 50%; margin-right: 8px" :style="{ backgroundColor: pieChartOptions.colors[props.index % 8] }"/>
                    {{ props.item.projectname ? props.item.projectname : '-' }}
                  </td>
                  <td>
                    <div style="display: flex; justify-content: space-between; width: 220px">
                      <Typography h5 semiBold style="width: 180px" :label="props.item.count ? `${(props.item.count * 100 / sumchart1).toFixed(1)}%` : '-'"/>
                      <span @click="props.expanded = !props.expanded" style="cursor: pointer; align-content: center;">
                        <v-divider vertical style="min-height: 23.75px;" />
                        <v-icon :style="{ width: '16px', height: '8px', color: '#0C2F53', marginLeft: '15px', marginBottom: '8px' }">
                          {{ props.expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                        </v-icon>
                      </span>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-slot:expand="props">
                <v-data-table
                  :headers="[
                    {
                      text: 'Step',
                      align: 'center',
                      key: 'stepname'
                    },
                    { text: 'Total', align: 'center', value: 'total' }
                  ]"
                  :items="props.item.stepdata"
                  hide-actions
                  hide-headers
                  class="elevation-1 expandtable"
                >
                  <template v-slot:items="props">
                    <tr class="depatable" >
                      <td class="text-xs-left" style="background-color: #E6F0FB">
                        <Typography h5 semiBold style="padding-left: 53px; width: 762px" :label="props.item.stepname ? `ขั้นตอน : ${props.item.stepname}` : '-'"/>
                      </td>
                      <td class="text-xs-left" style="background-color: #E6F0FB">
                        <Typography h5 semiBold style="width: 218px" :label="props.item.total ? `จำนวน : ${props.item.total}` : '-'"/>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </template>
            </v-data-table>
          </div>
          <div v-else>
            <Typography h2 bold label="ประเภทสมาชิก"/>
            <v-layout row wrap>
              <v-flex v-if="res2Array && res2Array.length" xs12 class="mt-4">
                <div>
                  <v-layout row wrap justify-center>
                    <v-flex xs1></v-flex>
                    <v-flex xs11>
                      <apexchart
                        :key="piechartkey2"
                        type="pie"
                        width="900"
                        class="member-count"
                        :options="pieChartOptions2"
                        :series="pieSeries2"
                      ></apexchart>
                    </v-flex>
                    <!-- <v-flex xs1></v-flex> -->
                  </v-layout>
                </div>
                <Typography h2 bold label="รายละเอียด" style="margin-bottom: 13px"/>
                <v-data-table
                  :headers="headers2"
                  :items="res2Array"
                  :loading="loading"
                  hide-actions
                  item-key="id"
                  class="elevation-1 expandtable"
                >
                  <template v-slot:items="props">
                    <tr class="depatable">
                      <td class="text-xs-left" style="display: flex; align-items: center; margin-left: 29px; font-weight: 600; width: 768px" :style="{ color: pieChartOptions2.colors[props.index % 8] }">
                        <div style="width: 12px; height: 12px; border-radius: 50%; margin-right: 8px" :style="{ backgroundColor: pieChartOptions2.colors[props.index % 8] }"/>
                        {{ props.item.name ? props.item.name : '-' }}
                      </td>
                      <td>
                        <Typography h5 semiBold style="width: 240px" :label="props.item.count ? `${(props.item.count * 100 / sumchart2).toFixed(1)}%` : '-'"/>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex v-if="res3Array && res3Array.length" xs12 class="mt-4">
                <div style="margin-top: 120px">
                  <v-layout row wrap justify-center>
                    <v-flex xs1></v-flex>
                    <v-flex xs11>
                      <apexchart
                        :key="piechartkey3"
                        type="pie"
                        width="900"
                        class="member-count"
                        :options="pieChartOptions3"
                        :series="pieSeries3"
                      ></apexchart>
                    </v-flex>
                    <!-- <v-flex xs1></v-flex> -->
                  </v-layout>
                </div>
                <Typography h2 bold label="รายละเอียด" style="margin-bottom: 13px"/>
                <v-data-table
                  :headers="headers3"
                  :items="res3Array"
                  :loading="loading"
                  hide-actions
                  item-key="id"
                  class="elevation-1"
                >
                  <template v-slot:items="props">
                    <tr class="depatable">
                      <td class="text-xs-left" style="display: flex; align-items: center; margin-left: 29px; font-weight: 600; width: 768px" :style="{ color: pieChartOptions3.colors[props.index % 8] }">
                        <div style="width: 12px; height: 12px; border-radius: 50%; margin-right: 8px" :style="{ backgroundColor: pieChartOptions3.colors[props.index % 8] }"/>
                        {{ props.item.name ? props.item.name : '-' }}
                      </td>
                      <td>
                        <Typography h5 semiBold style="width: 240px" :label="props.item.count ? `${(props.item.count * 100 / sumchart3).toFixed(1)}%` : '-'"/>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <div v-else style="color: grey; font-size: 24px" class="mt-4 text-xs-center">ไม่พบข้อมูล</div>
      </div>
    </div>
  </div>
</template>

<script>
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import Typography from '@/components/elements/Typography.vue'
import api from '@/api'
import moment from 'moment'
import apexchart from 'vue-apexcharts'
import DatePicker from 'vue2-datepicker'
import Multiselect from 'vue-multiselect'
import importxlsx from '@/components/elements/importxlsx.vue';
export default {
  components: {
    DateFilter,
    apexchart,
    Typography,
    DatePicker,
    Multiselect,
  },
  data() {
    return {
      piechartkey: 0,
      piechartkey2: 0,
      piechartkey3: 0,
      sumchart1: 0,
      sumchart2: 0,
      sumchart3: 0,
      filterselect: { value: 1, label: 'เลือก' },
      pieSeries: [],
      pieSeries2: [],
      pieSeries3: [],
      res2Array: [],
      res3Array: [],
      expanded: [],
      status: [
        {
          label: 'โครงการ',
          value: 1
        },
        {
          label: 'ประเภทสมาชิก',
          value: 2
        },
      ],
      singleExpand: false,
      pieChartOptions: {
        plotOptions: {
          pie: {
            customScale: 0.8,
            offsetX: -30,
          }
        },
        colors: ['#1C64AF', '#B656C6', '#FFCD00', '#7DBDFF', '#FF9533', '#546E7A', '#ED5252', '#52C41A'],
        chart: {
          width: 288,
          height: 288,
          type: 'pie',
        },
        legend: {
          width: 485,
          offsetY: -10,
          offsetX: -70,
          itemMargin: {
            horizontal: 8,
            vertical: 5
          },
          labels: {
              useSeriesColors: true
          },
        },
        labels: [],
        dataLabels: {
          style: {
              fontSize: '16px',
          },
          dropShadow: {
              top: 1,
              left: 1,
              blur: 1,
              color: '#000',
              opacity: 0.45
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 400
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ],
      },
      pieChartOptions2: {
        plotOptions: {
          pie: {
            customScale: 0.8,
            offsetX: -30,
          }
        },
        chart: {
          width: 288,
          height: 288,
          type: 'pie',
        },
        legend: {
          width: 485,
          offsetY: -10,
          offsetX: -70,
          itemMargin: {
            horizontal: 8,
            vertical: 5
          },
          labels: {
              useSeriesColors: true
          },
        },
        labels: [],
        dataLabels: {
          style: {
              fontSize: '16px',
          },
          dropShadow: {
              top: 1,
              left: 1,
              blur: 1,
              color: '#000',
              opacity: 0.45
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 400
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ],
        colors: ['#7DBDFF', '#FF9533', '#ED5252', '#52C41A', '#1C64AF', '#B656C6', '#FFCD00', '#546E7A'],
      },
      pieChartOptions3: {
        plotOptions: {
          pie: {
            customScale: 0.8,
            offsetX: -30,
          }
        },
        chart: {
          width: 288,
          height: 288,
          type: 'pie',
        },
        legend: {
          width: 485,
          offsetY: -10,
          offsetX: -70,
          itemMargin: {
            horizontal: 8,
            vertical: 5
          },
          labels: {
              useSeriesColors: true
          },
        },
        labels: [],
        dataLabels: {
          style: {
              fontSize: '16px',
          },
          dropShadow: {
              top: 1,
              left: 1,
              blur: 1,
              color: '#000',
              opacity: 0.45
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 400
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ],
        colors: ['#1C64AF', '#B656C6', '#FFCD00', '#7DBDFF', '#FF9533', '#546E7A', '#ED5252', '#52C41A'],
      },
      headers: [
        {
          text: 'ชื่อโครงการ',
          value: 'projectname',
          sortable: false,
        },
        {
          text: 'เปอร์เซ็นต์',
          value: 'count',
          sortable: false,
        },
      ],
      headers2: [
        {
          text: 'ชื่อประเภทสมาชิก',
          align: 'left',
          value: 'projectname',
          sortable: false,
        },
        {
          text: 'เปอร์เซ็นต์',
          align: 'left',
          value: 'count',
          sortable: false,
        }
      ],
      headers3: [
        {
          text: 'ชื่อประเภทนิติบุคคล',
          align: 'left',
          value: 'projectname',
          sortable: false,
        },
        {
          text: 'เปอร์เซ็นต์',
          align: 'left',
          value: 'count',
          sortable: false,
        }
      ],
      loading: false,
      selectedDate: [new Date(Date.now() - 14 * 24 * 60 * 60 * 1000), new Date(new Date())],
      data: []
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    onChangeDate() {
      this.getData()
      this.fetchdata()
      this.sumchart1 = 0
      this.sumchart2 = 0
      this.sumchart3 = 0
    },
    async fetchdata() {
      const data = {
        datefrom: moment(this.selectedDate[0]).format('YYYY-MM-DD'),
        dateto: moment(this.selectedDate[1]).format('YYYY-MM-DD'),

      }
      this.loading = true
      let res2 = await api.getusersapplyprojectcounttype(data)
      let res3 = await api.getusersapplyprojectcountentitytype(data)

      this.pieSeries2 = []
      this.res2Array = []
      this.pieChartOptions2.labels = []
      for (const key in res2) {
        this.pieSeries2.push(res2[key])
        this.pieChartOptions2.labels.push(key)
        this.res2Array.push({ name: key, count: res2[key] })
        this.sumchart2 = this.sumchart2 + res2[key]
      }
      this.piechartkey2 += 1

      this.pieSeries3 = []
      this.pieChartOptions3.labels = []
      this.res3Array = []
      for (const key in res3) {
        this.pieSeries3.push(res3[key])
        this.pieChartOptions3.labels.push(key)
        this.res3Array.push({ name: key, count: res3[key] })
        this.sumchart3 = this.sumchart3 + res3[key]
      }
      this.piechartkey3 += 1
    },
    getData() {
      this.loading = true
      var data = {
        datefrom: moment(this.selectedDate[0]).format('YYYY-MM-DD'),
        dateto: moment(this.selectedDate[1]).format('YYYY-MM-DD'),

      }
      api.depausersapplyprojectapplicants(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200) {
          this.data = response.data
          this.setupPieChart(response.data)
        }
      })
    },
    setupPieChart(data) {
      this.pieSeries = data.map(el => parseInt(el.count))
      this.pieChartOptions.labels = data.map((el, idx) => (el.projectname ? el.projectname : 'ไม่ระบุ'))
      this.piechartkey++
      this.sumchart1 = this.pieSeries.reduce((total, current) => total + current);
    },
  },
  computed: {
    shortcuts() {
      const currentDate = new Date()
      const twentyFourHoursAgo = new Date(Date.now() - 24 * 60 * 60 * 1000)
      const fortyEightHoursAgo = new Date(Date.now() - 48 * 60 * 60 * 1000)
      const oneWeekAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
      return [
        {
          text: '24 ชั่วโมงที่แล้ว',
          onClick() {
            const end = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate(),
              currentDate.getHours(),
              currentDate.getMinutes(),
              currentDate.getSeconds()
            )
            const start = new Date(
              twentyFourHoursAgo.getFullYear(),
              twentyFourHoursAgo.getMonth(),
              twentyFourHoursAgo.getDate(),
              twentyFourHoursAgo.getHours(),
              twentyFourHoursAgo.getMinutes(),
              twentyFourHoursAgo.getSeconds()
            )

            const date = [start, end]
            return date
          }
        },
        {
          text: '48 ชั่วโมงที่แล้ว',
          onClick() {
            const start = new Date(
              fortyEightHoursAgo.getFullYear(),
              fortyEightHoursAgo.getMonth(),
              fortyEightHoursAgo.getDate(),
              fortyEightHoursAgo.getHours(),
              fortyEightHoursAgo.getMinutes(),
              fortyEightHoursAgo.getSeconds()
            )
            const end = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate(),
              currentDate.getHours(),
              currentDate.getMinutes(),
              currentDate.getSeconds()
            )

            const date = [start, end]
            return date
          }
        },
        {
          text: 'อาทิตย์ที่แล้ว',
          onClick() {
            const start = new Date(
              oneWeekAgo.getFullYear(),
              oneWeekAgo.getMonth(),
              oneWeekAgo.getDate(),
              oneWeekAgo.getHours(),
              oneWeekAgo.getMinutes(),
              oneWeekAgo.getSeconds()
            )
            const end = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate(),
              currentDate.getHours(),
              currentDate.getMinutes(),
              currentDate.getSeconds()
            )
            // return a Date
            const date = [start, end]
            return date
          }
        },
        {
          text: '15 วันที่แล้ว',
          onClick() {
            const start = new Date(Date.now() - 14 * 24 * 60 * 60 * 1000)
            const end = new Date(currentDate)
            // return a Date
            const date = [start, end]
            return date
          }
        },
        {
          text: 'เดือนที่แล้ว',
          onClick() {
            const start = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)
            const end = new Date(
              new Date().getFullYear(),
              new Date().getMonth(),
              new Date().getDate()
            )
            // return a Date
            const date = [start, end]
            return date
          }
        },
        {
          text: '365 วันที่แล้ว',
          onClick() {
            const start = new Date(Date.now() - 365 * 24 * 60 * 60 * 1000)
            const end = new Date()
            // return a Date
            const date = [start, end]
            return date
          }
        }
      ]
    }
  },
}
</script>

<style
lang="scss" scoped>
.apexcharts-legend-series,
.apexcharts-legend-series:hover {
  color: inherit !important;
}
.toolbartitle {
  padding: 0px !important;
}




</style>





// WEBPACK FOOTER //
// src/components/view/projectMemberCount/main.vue